import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Layout";
import TermsConditions from "@/components/TermsConditions";

const TermsConditionsPage = () => (
  <Layout>
    <TermsConditions />
  </Layout>
);

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default TermsConditionsPage;
